import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import useIsAuth from "../../../hooks/useIsAuth";
import { authActions } from "../../../redux/actions";
import style from "./login.module.css";
import emailLogo from "../../../Assets/emailLogo.svg";
import PasswordLogo from "../../../Assets/PasswordLogo.svg";
import google from "../../../Assets/google.svg";
import { Box, Circle, Flex, Spinner } from "@chakra-ui/react";
import swAlert from "sweetalert2";
import openEye from "../../../Assets/openEye.png";
import closedEye from "../../../Assets/closedEye.png";
import recruiter from "../../../Assets/studentlogo.svg";
import { useToast } from "@chakra-ui/react";
import { getSearchParam, hasSearchParam } from "helper/helper";

const Login = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    // profile: "recruiter",
  });
  const [passwordType, setPasswordType] = useState(false);
  const isAuth = useIsAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toast = useToast();
  const changeHandler = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const togglePassword = () => {
    setPasswordType(!passwordType);
  };
  const submitHandler = (e) => {
    e.preventDefault();

    if (formData.email && formData.password) {
      dispatch(authActions.login(formData));
    } else if (formData.email == "" || formData.password == "" || !isAuth) {
      // swAlert.fire("Please Check Credentials...");
      toast({
        title: "Please Check Credentials...",
        status: "error",
        duration: 1000,
        position: "top",
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    if (isAuth) {
      // swAlert.fire("Logged-in succesfully");
      const user = JSON.parse(localStorage.getItem("user"));

      const redirectLink = hasSearchParam();
      if (redirectLink) {
        window.location.href = redirectLink;
        return;
      }
      // console.log(user);
      if (user.companyId && user.profile === "recruiter") {
        swAlert.fire({
          icon: "success",
          text: "Logged-in succesfully",
          timer: 1300,
        });
        window.location.href = "/hiring/recruiter/findtalent";
      } else if (user.profile !== "recruiter") {
        window.location.href = "/hiring/student/profile";
        return;
      } else if (user.profile === "recruiter" && user._id) {
        swAlert.fire({
          icon: "info",
          text: "Please Select/Setup Company",
          timerL: 1300,
        });
        window.location.href = "/hiring/recruiter/selectCompany";
        return;
      }
    }
  }, [isAuth]);
  return (
    <main className={style.login}>
      <div className={style.loginWrapper}>
        <div className={style.rightContainer}>
          <div className={style.headingContainer}>
            {/* <h1>Namaskaram!</h1> */}
            <img src={recruiter} alt="recruiterlogo" />
            <div className={style.namaskaram}>Namaskaram!</div>
            <div className={style.welcome}>Welcome Back</div>
          </div>
          <form className={style.loginForm}>
            <div className={style.inputField}>
              <Circle size={5}>
                <img height={"100%"} width={"100%"} src={emailLogo} alt="" />
              </Circle>
              <input
                type="text"
                name="email"
                value={formData.email}
                onChange={changeHandler}
                placeholder="Email address"
                autoComplete="off"
              />
            </div>
            <div className={style.inputField}>
              <Circle size={5}>
                <img height={"100%"} width={"100%"} src={PasswordLogo} alt="" />
              </Circle>
              <input
                type={passwordType ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={changeHandler}
                placeholder="Password"
                autoComplete="off"
              />
              <Flex justify={"center"} align={"center"} h={4} w={6}>
                <img
                  src={passwordType ? openEye : closedEye}
                  onClick={togglePassword}
                  style={
                    passwordType
                      ? {
                          cursor: "pointer",
                          width: "100%",
                          marginTop: "4px",
                          height: "90%",
                        }
                      : { cursor: "pointer", width: "100%", marginTop: "4px" }
                  }
                  alt="eyeIcon"
                />
              </Flex>
            </div>
            <div className={style.forget}>
              <a
                href="/hiring/forgot-password"
                style={{
                  textDecoration: "underline",
                  color: "blue",
                  fontfamily: "Roboto",
                  fontSize: "0.8rem",
                  // display: 'none',
                }}
              >
                Forgot Password
              </a>
            </div>
            <button
              type="submit"
              onKeyDown={(e) => e.key === "enter" && submitHandler(e)}
              onClick={submitHandler}
              className={style.loginButton}
            >
              Login
            </button>

            <Link className={style.signupButton} to="/hiring/signup">
              Sign up
            </Link>
            {/* sign in btn */}
            {/* <Link to="/hiring/student/signup">
              <p type="button" onClick={submitHandler} className={style.signin}>
                Signin
              </p>
            </Link> */}
          </form>
          {/* <div className={style.horizontalRule}>
            <div className={style.rule} />
            <p className={style.horizontalRuleMessage}>or</p>
            <div className={style.rule} />
          </div>
          <div className={style.socialBtnContainer}> */}
          {/* {[{ provider: "Google" }].map((btnItem, idx) => (
              <button
                className={style.socialBtn}
                key={`${btnItem.provider}${idx}`}
              >
                <div className={style.inputPrefix}>
                  <img src="" alt="" />
                </div>
                <div className={style.btnText}>{btnItem.provider}</div>
              </button>
            ))} */}
          {/* <p type="button" onClick={submitHandler} className={style.google}>
              <img src={google} alt="" />
              Google
            </p>
          </div> */}
          {/* <div className={style.registerSwitchContainer}>
            <div className={style.registerMessage}>I'm new here</div>
            <Link
              className={style.registerSwitch}
              to="/hiring/recruiter/signup"
            >
              Sign up
            </Link>
          </div> */}
          <div className={style.terms}>
            <a href="/privacy">Privacy Policy</a>
            <a href="/t&c">Terms & Conditions</a>
          </div>
        </div>
      </div>
    </main>
  );
};
export default Login;
